// extracted by mini-css-extract-plugin
export default {"container":"SearchBar__container--18pPG","input":"SearchBar__input--3KmSf","searchIcon":"SearchBar__searchIcon--239tw","loadingIcon":"SearchBar__loadingIcon--14A4r"};